import React from 'react'
import Header from '../../../../shared/sections/Header'
import FirstView from '../../../../shared/sections/FirstView'
import Annotation from '../../../../../googleAd/shared/sections/FirstView/Annotation'
import { zenkokuConfig } from '../../config'
import styles from './ZenkokuSpLandingPage.module.css'
import VerticalEntryForm from '../../../../shared/forms/VerticalEntryForm'
import { StepProvider } from '@/components/Context/StepContext'
import { ZenkokuSpLandingPageProps } from './types.ts'
import { useAbTestGtm, useAbTestPattern } from '@/components/utils/abTest'
import { SlimFirstView } from '@/components/Common/SlimFirstView'
import { CompanyLogoStrip } from '@/components/Common/CompanyLogoStrip'
import Footer from '../../../../shared/sections/Footer'

const ZenkokuSpLandingPage: React.FC<ZenkokuSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()
    // DEV-3484: A=現行のヒーローFV / B=instagram_asc・googleAd（DEV-3419）と同じ
    // No.1帯＋企業ロゴ帯＋調査注記。配分と対象URLは settings.ts を参照
    const { isB, isResolved } = useAbTestPattern()

    return (
        <div className={styles.zenkokuSpLandingPage}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header
                    id='renewal_top'
                    dataViewLabel={dataViewLabel('HD')}
                />
                {/* 判定が確定するまでFV自体を描かない。初回レンダーはcookie未読で必ずA扱いになり、
                    素で分岐するとB割当でも現行FVが数十msDOMに載る。現行FVは素のラベル
                    CT_FirstView を持つため、GTMが拾うとB利用者の表示がA側の計測値に混ざる
                    （DEV-3379で実測済み）。Aはサフィックスが付かずラベルが変化しないので、
                    DEV-3390で行っていた key での要素作り直し（DEV-3574で不要になり削除済み。
                    詳細はGit履歴を参照）は不要 */}
                {isResolved && (isB ? (
                    <>
                        <SlimFirstView dataViewLabel={dataViewLabel('CT_FirstView')} />
                        <CompanyLogoStrip />
                    </>
                ) : (
                    <FirstView dataViewLabel={dataViewLabel('CT_FirstView')} />
                ))}
                <VerticalEntryForm
                    prefectures={prefectures}
                    config={zenkokuConfig}
                />
                {/* Bの帯画像には「求人数No.1※」が入るが、Aの現行FV画像に焼き込まれている
                    調査注記は消えるため、googleAdと同じ注記をここで補う（DEV-3419・DEV-3480と同じ扱い）。
                    VerticalEntryFormとの間に要素を挟まないこと。VerticalEntryForm.module.cssの
                    `.vertical + p` が外れて地のベージュが途切れる */}
                {isB && <Annotation />}
                <Footer />
            </StepProvider>
        </div>
    )
}

export default ZenkokuSpLandingPage
